var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dokan-logical-container"},[_c('ul',[_c('li',{staticClass:"dokan-logical-label-li"},[_c('div',{staticClass:"level-condition"},[_c('span',[_vm._v(_vm._s(_vm.event.condition_text.prefix))])])])])])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }